import axios from 'axios';

import { getCurrentSessionIdToken } from '../queries/AuthToken'
import { ContactListData } from '../types/ContactListData';

const baseUrl  : string = process.env.REACT_APP_API_ENDPOINT ?? "";


const getHeaders = async () => {
    const token = await getCurrentSessionIdToken();

    return {
        "Accept": "application/json",
        "Authorization": 'Bearer ' + token
    }
}


export const getContactList = async (params:any): Promise<ContactListData> => {
    const [_,id] = params.queryKey;

    const result:ContactListData = {
        contacts: [],
    };

    const data = await axios.get(`${baseUrl}/contacts`,
            {headers: await getHeaders()})
        .then(resp => {
            return resp.data;
        })
        .catch(err => {
            if (err.response) {
                if (err.response.status === 404) {
                    return null;
                }
            }
            
            // TODO: Maybe we'd throw a toast or something up here?
            console.error(err);
            return null;
        });

    if (!data) {
        return result;
    }

    return data;
}